import {    
    SessionKeys,
    dateRangeCustomShrts
} from '../commons';
import dayjs from "dayjs";

let sessionAction = {
    set: function (key, value) {
        try {
            if (value) {
                window.sessionStorage.setItem(key, value);
            }
        } catch (e) {
            console.log("Session Storage is not enabled.");
        }
    },
    get: function (key) {
        try {
            if (window.sessionStorage[key] !== undefined) {
                return window.sessionStorage.getItem(key);
            } else {
                return undefined;
            }
        } catch (e) {
            return undefined;
        }
    },
    delete: function (key) {
        try {
            if (key) {
                window.sessionStorage.removeItem(key);
            }
        } catch (e) {
            console.log(e);
        }
    }
}

let dateRangeReceivableShrts = [
    {
        name: window.globalLanguage.datePicker.lastMonth,
        dates: function () {
            var start = dayjs().subtract(1,'month').startOf('month').$d;
            var end = dayjs().subtract(1,'month').endOf('month').$d;
            return [start, end];
        }
    }
];

export const SalesTracker = {
    data: function() {
        return {
            brokersList: [],
            selectMultiple: true,
            multiselectFocus: false,
            errors: [],
            products: [],
            companies: window.bnJS.companiesAndProducts || [],
            allProducts: [],
            isAgentTreeOpen: false,
            hasAffiliates: false,
            hasAffiliatesArray: [],
            myself: {
                affiliateId: window.bnJS.loaderVersion,
                agencyName: window.bnJS.bName,
                isChecked: true,
                affiliateType: window.bnJS.affiliateType,
                affiliateName: window.bnJS.affiliateName
            },
            triggerUpdate: true,
            startDateRange: '',
            endDateRange: ''
        }
    },
    created: function () {
        if (this.companies && this.companies.length) {
            this.products = this.companies.map(item => item.products).reduce((a, b) => a.concat(b)).sort(function (a, b) {
                const aTxt = a.productName ? a.productName.toString().toLowerCase() : '';
                const bTxt = b.productName ? b.productName.toString().toLowerCase() : '';
                if (aTxt < bTxt) return -1;
                if (aTxt > bTxt) return 1;
                return 0;
            });
        }
        this.removeDuplicateProducts();
        this.allProducts = this.products;

        // Split Sub Brokers into an array
        let _formSession = sessionAction.get(SessionKeys.searchPolicyFields);
        if (_formSession) _formSession = JSON.parse(_formSession);

        if(_formSession && window.bnJS.thisPage === 'search-policies') {
            this.syncCheckedwithSessionRecursive(window.bnJS.subAgents, true);
        } else {
            this.selectAllRecursive(window.bnJS.subAgents);
        }

        let allSubBrokers = window.bnJS.subAgents.filter(item => {
            return item.affiliateId !== 'self' && item.affiliateId !== 'affiliates';
        });

        let selfNaffiliates = window.bnJS.subAgents.filter(item => {
            if(!_formSession) item.isChecked = true;
            return item.affiliateId == 'self' || item.affiliateId == 'affiliates';
        });

        let allSubAgents = {
            affiliateId: 'allSubAgents',
            affiliateType: '1',
            agencyName: window.bnJS.loaderType == 2 ? window.globalLanguage.allSubAccounts : window.globalLanguage.allSubAgents,
            isChecked: true,
            subAgents: allSubBrokers
        }

        let unAssigned = {
            affiliateId: '-1',
            affiliateType: '-1',
            agencyName: window.globalLanguage.unassigned,
            isChecked: this.isUnAssignedChecked(_formSession),
            subAgents: []
        }

        this.brokersList = selfNaffiliates;
        
        if (allSubBrokers.length) {
            this.brokersList.push(allSubAgents);
        }

        if (this.myself.affiliateId === 'none') {
            this.brokersList.push(unAssigned);
        }

        let isSelfNaffiliate = {
            self: false
        };
        let i = 0;
        let agentLength = this.brokersList.length;
        for (i; i < agentLength; i++) {
            if (this.brokersList[i].affiliateId === 'self') {
                isSelfNaffiliate.self = true;
                this.hasAffiliatesArray.push(this.brokersList[i]);
                break;
            }
        }

        if (this.myself.affiliateId === 'none') {
            this.hasAffiliatesArray.push(unAssigned);
        }

        this.hasAffiliates = isSelfNaffiliate.self;
        if (this.hasAffiliates) {
            setTimeout(() => {
                let _self = document.querySelectorAll('[affiliate-id="self"] .agent');
                let $self = [];
                for (let i = 0; i < _self.length; i++) {
                    $self.push(_self[i]);
                }
                $self.forEach(element => element.classList.add('agent-selected'));
            }, 1000);
        }

    },
    mounted: function () {
        window.addEventListener('click', e => {
            let $el = $(e.target);
            if (!$el.parents().closest('#agentTree').length && !$el.parents().closest('.selected-brokers').length && !$el.hasClass('selected-brokers')) {
                this.isAgentTreeOpen = false;
            }
        });

        // Initializing jQuery date range picker
        this.initializeDateRange();

        let _resizeEvt;

        window.onresize =() => {            
            if(!_resizeEvt) {
                _resizeEvt = setTimeout(()=>{                   
                    $('.o-Icon--calendar').each((i,e)=>{
                        $(e).data('dateRangePicker').destroy();
                    })
                    this.initializeDateRange();
                    clearTimeout(_resizeEvt);
                    _resizeEvt = null;
                },250)
            }
        };
    },
    computed: {
        disableAgentSelection: function() {
            if(this.form.onlineOnly) {
                this.isAgentTreeOpen = false;
            }
        }
    },
    methods: {
        toggleSubAgentContainer: function (e) {
            if (!this.form.onlineOnly && ($(e.target).hasClass('selected-brokers') || $(e.target.parentElement).hasClass('selected-brokers'))) {
                this.isAgentTreeOpen = !this.isAgentTreeOpen;
            }
        },
        onlyCurrentAgent: function () {
            this.form.affiliateIds = [];
            this.form.affiliateIds.push(window.bnJS.loaderVersion);
            if (this.hasAffiliates) {
                this.hasAffiliatesArray.forEach(item => {
                    this.form.affiliateIds.push(this.addSubAgentsRecursive(item));
                });
                //document.querySelector('ul.tree-wrapper').classList.add('has-self');
            }
        },
        addSubAgentsRecursive: function (agent) {
            if (agent.subAgents && agent.subAgents.length) {
                agent.subAgents.forEach(item => {
                    this.form.affiliateIds.push(this.addSubAgentsRecursive(item));
                });
            }
            return agent.affiliateId;
        },
        selectAllSubAgents: function () {
            this.form.affiliateIds = [];
            this.form.affiliateIds.push(window.bnJS.loaderVersion);

            window.bnJS.subAgents.forEach(item => {
                this.form.affiliateIds.push(this.addSubAgentsRecursive(item));
            });

            if (this.myself.affiliateId === 'none') {
                this.form.affiliateIds.push("-1");
            }
        },
        selectAll: function (key) {
            let _allCheckboxes = document.querySelectorAll(".tree-wrapper input[type=checkbox]");            
            let $allCheckboxes = [];
            for (let i = 0; i < _allCheckboxes.length; i++) {
                $allCheckboxes.push(_allCheckboxes[i]);
            }
            if(key === 'select') {
                $allCheckboxes.forEach(item => {
                    item.checked = false;
                    item.click();
                });
            } else {
                $allCheckboxes.forEach(item => {
                    item.checked = true;
                    item.click();
                });
                this.form.affiliateIds = [];
            }
        },
        syncCheckedwithSessionRecursive: function(agent, onCreated) {

            let _formSession = sessionAction.get(SessionKeys.searchPolicyFields);
            if (_formSession) {
                _formSession = JSON.parse(_formSession);
            }

            if (Array.isArray(agent)) {
                agent.forEach(item => {
                    this.syncCheckedwithSessionRecursive(item, onCreated)
                })
            } else {
                agent.isChecked = _formSession && _formSession.affiliateIds.indexOf(agent.affiliateId) !== -1 && onCreated ? true : this.form.affiliateIds.indexOf(agent.affiliateId) > -1 ? true : false;
                
                if(agent.subAgents && agent.subAgents.length > 0) {
                    agent.subAgents.forEach(subAgent => {
                        this.syncCheckedwithSessionRecursive(subAgent, onCreated)
                    })
                }
            }
        },
        selectAllRecursive(agent) {
            if (!this.myself.isChecked) {
                this.myself.isChecked = true;
            }
            if (Array.isArray(agent)) {
                agent.forEach(item => {
                    this.selectAllRecursive(item )
                })
            } else {
                agent.isChecked = true
                if(agent.subAgents && agent.subAgents.length > 0) {
                    agent.subAgents.forEach(subAgent => {
                        this.selectAllRecursive(subAgent)
                    })
                }
            }
        },
        isUnAssignedChecked(_formSession) {
            if(_formSession && bnJS.thisPage === 'search-policies') {
                return _formSession.affiliateIds.indexOf('-1') !== -1 ? true : false; 
            } else {
                return true;
            }
        },        
        initializeDateRange: function () {
            var self = this;
            let lang = 'en';            
            let dateFormat = 'MM/DD/YYYY';
            if(window.globalLanguage && window.globalLanguage.lang === 'zh') {
                dateFormat = 'YYYY-MM-DD';
                lang = 'cn';                
            } else if(window.globalLanguage && window.globalLanguage.lang === 'es') {
                dateFormat = 'DD/MM/YYYY';
                lang = 'es';                
            }

            const payDateElm = $('#payDate-date .o-Icon--calendar');
            if (payDateElm && payDateElm.length) {
                payDateElm.dateRangePicker({
                    autoClose: true,
                    format: dateFormat,
                    separator: ' ' + window.globalLanguage.datePicker.to + ' ',
                    language: lang,
                    showShortcuts: true,
                    shortcuts: null,
                    customShortcuts: dateRangeCustomShrts,
                    setValue: function (s) {
                        self.form.payDate = s;
                    },
                    getValue: function () {
                        const inValid = self.$v.form.payDate.$invalid;
                        const valueToReturn = inValid ? '' : self.form.payDate;
                        setTimeout(()=>{
                            if (!valueToReturn && !self.form.payDate) {
                                payDateElm.data('dateRangePicker').clear();
                            }
                        });
                        return valueToReturn;                            
                    }
                });
            }

            const transcationDateElm = $('#transaction-date .o-Icon--calendar');
            if (transcationDateElm && transcationDateElm.length) {
                transcationDateElm.dateRangePicker({
                    autoClose: true,
                    format: dateFormat,
                    separator: ' ' + window.globalLanguage.datePicker.to + ' ',
                    language: lang,
                    showShortcuts: true,
                    shortcuts: null,
                    customShortcuts: dateRangeCustomShrts,                
                    setValue: function (s) {
                        self.form.transactionDate = s;              
                    },
                    getValue: function () {
                        const inValid = self.$v.form.transactionDate.$invalid;
                        const valueToReturn = inValid ? '' : self.form.transactionDate;
                        setTimeout(()=>{
                            if (!valueToReturn && !self.form.transactionDate) {
                                transcationDateElm.data('dateRangePicker').clear();
                            }
                        });
                        return valueToReturn;
                    }
                });
            }

            const effectiveDateElm = $('#effective-date .o-Icon--calendar');
            if (effectiveDateElm && effectiveDateElm.length) {
                effectiveDateElm.dateRangePicker({
                    autoClose: true,
                    format: dateFormat,
                    separator: ' ' + window.globalLanguage.datePicker.to + ' ',
                    language: lang,
                    showShortcuts: true,
                    shortcuts: null,
                    customShortcuts: dateRangeCustomShrts,                
                    setValue: function (s) {
                        self.form.effectiveDate = s;              
                    },
                    getValue: function () {
                        const inValid = self.$v.form.effectiveDate.$invalid;
                        const valueToReturn = inValid ? '' : self.form.effectiveDate;
                        setTimeout(()=>{
                            if (!valueToReturn && !self.form.effectiveDate) {
                                effectiveDateElm.data('dateRangePicker').clear();
                            }
                        });
                        return valueToReturn;                            
                    }
                });
            }

            const expirationDateElm = $('#expiration-date .o-Icon--calendar');
            if (expirationDateElm && expirationDateElm.length) {
                expirationDateElm.dateRangePicker({
                    autoClose: true,
                    format: dateFormat,
                    separator: ' ' + window.globalLanguage.datePicker.to + ' ',
                    language: lang,
                    showShortcuts: true,
                    shortcuts: null,
                    customShortcuts: dateRangeCustomShrts,
                    setValue: function (s) {
                        self.form.expirationDate = s;
                    },
                    getValue: function () {
                        const inValid = self.$v.form.expirationDate.$invalid;
                        const valueToReturn = inValid ? '' : self.form.expirationDate;
                        setTimeout(()=>{
                            if (!valueToReturn && !self.form.expirationDate) {
                                expirationDateElm.data('dateRangePicker').clear();
                            }
                        });
                        return valueToReturn;                            
                    }
                });
            }

            if(this.startDateRange && this.endDateRange) {                
                if(window.globalLanguage && window.globalLanguage.lang === 'zh') {
                    let splitStart = this.startDateRange.split('/');
                    let splitEnd = this.endDateRange.split('/');
                    this.startDateRange = splitStart[2] + '-' + splitStart[0] + '-' + splitStart[1];
                    this.endDateRange = splitEnd[2] + '-' + splitEnd[0] + '-' + splitEnd[1];                        
                } else if(window.globalLanguage && window.globalLanguage.lang === 'es') {   
                    let splitStart = this.startDateRange.split('/');
                    let splitEnd = this.endDateRange.split('/');
                    this.startDateRange = splitStart[1] + '-' + splitStart[0] + '-' + splitStart[2];
                    this.endDateRange = splitEnd[1] + '-' + splitEnd[0] + '-' + splitEnd[2];                        
                }
                $('.o-Icon--calendar').data('dateRangePicker').setDateRange(this.startDateRange,this.endDateRange);
            }
        },
        removeDuplicateProducts: function () {
            let allNames = [];
            let allProducts = [];
            this.products.forEach((item, i) => {
                if (allNames.indexOf(item.productName) === -1) {
                    allNames.push(item.productName);
                    allProducts.push(item);
                }
            });
            this.products = allProducts;
        }

    }
}